import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { FrontEndMapping } from '../../../../core/configuration/front-end-mapping';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";
import { UrlSettingsCore } from '../../../../core/configuration/url-settings-core';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { UserManager } from "../../../../core/services/user-manager";
import { NomiRuoliUtente } from "../../../configuration/nomi-descrittori-sezione";
import { BaseForm } from '../../../form/base-Form';
import { FascicoloLight } from "../../../models/fascicolo/fascicolo-light";
import { TipoFascicolo } from '../../../models/tipologiche/tipo-fascicolo';
import { TipoGenericoRimovibile } from '../../../models/tipologiche/tipo-generico-rimovibile';
import { TipoPratica } from '../../../models/tipologiche/tipo-pratica';

export const orderCategoria: { [id: string]: number } = {
  'Stragiudiziale': 1,
  'Giudiziale': 2,
  'Esecuzione': 3,
  'Opposizione': 4,
};

@Component({
    selector: 'div [fascicolo-select-modal]',
  templateUrl: 'fascicolo-select-modal.component.html'
})

export class FascicoloSelectModal extends BaseForm {

  listaFascicoliPerCategoria: {categoria: TipoGenericoRimovibile, tipiFascicolo: TipoFascicolo[]}[] = [];
  tipoPratica: TipoPratica;
  idPratica: string;
  isCopiaFascicolo: boolean;
  fascicoloOrigine: FascicoloLight;
  ruoloVisualizzatoreAmianto: boolean;
  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();

  constructor(protected operationService: OperationsService, private campiForm: FormBuilder, private helpers: HelpersService, private frontEndMapping: FrontEndMapping, private userManager: UserManager) {
    super();
  }

  inizializza(tipoPratica: TipoPratica, idPratica: string, fascicoloOrigine: FascicoloLight = null) {
    if (fascicoloOrigine) {
      this.isCopiaFascicolo = true;
      this.fascicoloOrigine = fascicoloOrigine;
    }
    this.tipoPratica = tipoPratica;
    this.idPratica = idPratica;
    this.listaFascicoliPerCategoria = [];
    // console.log(this.userManager.getUser().username);
    this.populateTipiFascicolo();
  }

  checkDescrittoreAmianto(descrittori) {
    this.ruoloVisualizzatoreAmianto = descrittori.utente.ruoli.findIndex(el => el.id === NomiRuoliUtente.VISUALIZZATORE_AMIANTO) !== -1;
    this.populateTipiFascicolo();
  }

  populateTipiFascicolo() {
    if (this.listaFascicoliPerCategoria.length === 0 && this.tipoPratica) {
      this.helpers.getTipiFascicolo(this.tipoPratica.id).subscribe(response => this.creaListaFascicoliPerCategoria(response.sort((a, b) : number => {
          if (a.label < b.label) { return -1; };
          if (a.label > b.label) { return 1; };
          return 0;
      })));
    }
  }

  creaListaFascicoliPerCategoria(listaTipiFascicolo: TipoFascicolo[]) {
    this.listaFascicoliPerCategoria = [];
    for (let tipoFascicolo of listaTipiFascicolo) {
      let founded = false;
      for (let categoriaTipiFascicoli of this.listaFascicoliPerCategoria) {
        if (categoriaTipiFascicoli.categoria.id === tipoFascicolo.categoria.id) {
          categoriaTipiFascicoli.tipiFascicolo.push(tipoFascicolo);
          founded = true;
        }
      }
      if (!founded) {
        let nuovaCategoriaTipiFascicolo: { categoria: TipoGenericoRimovibile, tipiFascicolo: TipoFascicolo[] } = {
          categoria: tipoFascicolo.categoria,
          tipiFascicolo: [tipoFascicolo]
        };
        this.listaFascicoliPerCategoria.push(nuovaCategoriaTipiFascicolo);
      }
    }

    this.listaFascicoliPerCategoria.sort((a, b): number => {
      if (orderCategoria[a.categoria.label] < orderCategoria[b.categoria.label]) {
        return -1;
      }
      if (orderCategoria[a.categoria.label] > orderCategoria[b.categoria.label]) {
        return 1;
      }
      return 0;
    });
  }

  filterListFacicoliPerCategoriaRoleamianto() {
      this.listaFascicoliPerCategoria = this.listaFascicoliPerCategoria.map(el => {
        if (el.tipiFascicolo.findIndex(e => e.endpoint === 'amianto') !== -1) {
          return {
            categoria: el.categoria,
            tipiFascicolo: [el.tipiFascicolo.find(e => e.endpoint === 'amianto')]
          };
        }
      });
      this.listaFascicoliPerCategoria = [...this.listaFascicoliPerCategoria.filter(el => {
        return el != null;
      })];
  }

  getPathFascicoloFromIdTipo(idTipoFascicolo: string): string {
    // let tipoFascicolo = FrontEndMapping.tipiFascicolo[idTipoFascicolo];
    let tipoFascicolo = '';
    this.frontEndMapping.getListTipiFascicolo(idTipoFascicolo).subscribe(res => {
      tipoFascicolo = res;
    });
    // let tipoPratica = FrontEndMapping.tipiPratica[this.tipoPratica.id];
    let tipoPratica = '';
    this.frontEndMapping.getListTipiPratica(this.tipoPratica.id).subscribe(res => {
      tipoPratica = res;
    });
    return '/' + UrlSettingsCore.URL_CREAZIONE_FASCICOLO + '/' + tipoPratica + '/' + tipoFascicolo + '/' + this.idPratica;
  }
}
